// extracted by mini-css-extract-plugin
export default {"toggleButtonAssoc":"ObjAssocMobile_toggleButtonAssoc__uGihm","objAssoc":"ObjAssocMobile_objAssoc__Kw+B2","taglabel":"ObjAssocMobile_taglabel__nXZ-o"};